import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { currentKpiIdAtom } from '../atoms';
import kpiStore from '@globalStore/kpiStore';
import { DEFAULT_KPI_ID } from '@src/utils/kpi';

/**
 * When persisted overview KPI id is not in the SPI list (e.g. custom KPI deleted),
 * reset to default so MetricSelectorPopup / KPIDropdown do not show a raw orphan id.
 * Mirrors useKPI validation for the global atom, but updates overview persistence.
 */
export function useSyncOverviewKpiWithKpiList() {
  const [currentKpiId, setCurrentKpiId] = useAtom(currentKpiIdAtom);
  const kpiList = kpiStore((state) => state.kpiList);

  useEffect(() => {
    const list = kpiList;
    if (!list?.length) return;

    const existsInList = list.some((k: any) => k.kpiID === currentKpiId);
    const storeList = kpiStore.getState().kpiList;
    const existsInStore = storeList?.some((k: any) => k.kpiID === currentKpiId);

    if (currentKpiId == null) {
      setCurrentKpiId(DEFAULT_KPI_ID);
      return;
    }
    if (!existsInList && !existsInStore) {
      setCurrentKpiId(DEFAULT_KPI_ID);
    }
  }, [kpiList, currentKpiId, setCurrentKpiId]);
}
